// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const paths = [
    '/ui/informations-legales',
    '/ui/register',
    '/ui/register/insured',
    '/ui/contact/insured',
    '/ui/inform-verify-email',
    '/ui/valid-account'
];


export const columns_Entreprise = [
    {
        title: 'Assuré(s)',
        field: 'assure',
        maxWidth:100
        //value: account.profil.lastname,
    },
    {
        title: 'N° sécurité sociale',
        field: 'num_ss_phi',
        maxWidth:100
        //value: account.profil.lastname,
    },
    {
        title: 'N° dossier',
        field: 'NumDossierRac_phi',
        maxWidth:60
    },
    {
        title: 'Date début',
        field: 'dt_debut_periode_phi',
        maxWidth:60,
        customSort: (a, b) => {
            const dateA = parseDate(a.dt_debut_periode_phi);
            const dateB = parseDate(b.dt_debut_periode_phi);
            return dateA - dateB;
        },
    },
    {
        title: 'Date fin',
        field: 'dt_fin_periode_phi',
        maxWidth:60,
        customSort: (a, b) => {
            const dateA = parseDate(a.dt_fin_periode_phi);
            const dateB = parseDate(b.dt_fin_periode_phi);
            return dateA - dateB;
        },
        //render: rowData => {
        //  return rowData.dt_fin_periode_phi.replace(/(\d{4})(\d{2})(\d{2})/g, '$3/$2/$1')
        //},
    },
    {
        title: 'Total réglé',
        field: 'mt_total_phi',
        maxWidth:50,
        align: 'right',
    },
    {
        title: 'Date règlt',
        field: 'dt_rglt_cpta_phi',
        maxWidth:60,
        customSort: (a, b) => {
            const dateA = parseDate(a.dt_rglt_cpta_phi);
            const dateB = parseDate(b.dt_rglt_cpta_phi);
            return dateA - dateB;
        },
    },
];
export const  columns_Assure = [
    {
        title: 'N° dossier',
        field: 'NumDossierRac_phi',
        minWidth: 150
    },
    {
        title: 'Date début',
        field: 'dt_debut_periode_phi',
        minWidth: 170,
        customSort: (a, b) => {
            const dateA = parseDate(a.dt_debut_periode_phi);
            const dateB = parseDate(b.dt_debut_periode_phi);
            return dateA - dateB;
        },

    },
    {
        title: 'Date fin',
        field: 'dt_fin_periode_phi',
        minWidth: 150,
        customSort: (a, b) => {
            const dateA = parseDate(a.dt_fin_periode_phi);
            const dateB = parseDate(b.dt_fin_periode_phi);
            return dateA - dateB;
        },
    },
    {
        title: 'Total réglé',
        field: 'mt_total_phi',
        maxWidth:50,
        align: 'right',
    },
    {
        title: 'Date de règlement',
        field: 'dt_rglt_cpta_phi',
        minWidth: 150,
        customSort: (a, b) => {
            const dateA = parseDate(a.dt_rglt_cpta_phi);
            const dateB = parseDate(b.dt_rglt_cpta_phi);
            return dateA - dateB;
        },
    },
];

function parseDate(dateString) {
    const parts = dateString.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0]); // year, month (0-based), day
}

